/* eslint-disable react/no-children-prop */
import { IconButton, Tooltip } from '@chakra-ui/react';
import { Eye } from 'phosphor-react';
import React from 'react';

export const ViewButton = ({ onClick }: any) => {
  return (
    <Tooltip label="Visualizar" openDelay={300}>
      <IconButton
        onClick={onClick}
        color="content.subtle"
        icon={<Eye size={16} />}
        size="xs"
        mr="2px"
        variant="ghost"
        _hover={{ bg: 'surface.selected', color: 'content.strong' }}
        aria-label="Visualizar"
      />
    </Tooltip>
  );
};
